<template>
  <div
    :class="{
      wrapper: true,
      shouldHover: !active,
    }"
    :style="topHeight"
    @mouseover="handleMouseOver"
    @mouseout="handleMouseOut"
  >
    <div
      class="wrapper__text"
      :style="{
        backgroundImage: `url(${image.ImgthumbBlurLarge})`,
        backgroundSize: `${width * modifier}px ${height * modifier}px`,
        backgroundPosition: 'bottom',
      }"
    >
      <div
        class="colorOverlay"
        :style="{
          /* backgroundColor: badge.colors.dominant*/
          /* backgroundColor: `rgba(${$root.content.allImages[content.image].colors.Muted._rgb.join()}, 1)`, */
          /* backgroundColor: $root.content.overlayColor */
          /* background: `linear-gradient(45deg, #${content.colordark}, #${content.colorlight})`, */
           background: `#${content.colordark}`,
        }"
      />
      <div class="wrapper__text--inner">
        <h4>Barrier {{ content.barrier || 'TBC' }}</h4>
        <h3>{{ content.tab }}. {{ content.name }}</h3>
      </div>
    </div>

    <div class="badge" >
      <img :src="$root.content.badges[content.name.toLowerCase()]" :alt="`${content.name} silk`">
    </div>
    <div class="wrapper__image">
      <responsive-image
        :imageFiles="image"
        :image="image.Img200"
        :alt="`${content.name}`"
      />
      <!-- <img :src="image.Img200" alt=""> -->
    </div>

  </div>
</template>


<script>
import ResponsiveImage from '@/components/responsive-image'

export default {
  name: 'games-top',
  props: {
    content: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    ResponsiveImage,
  },
  data () {
    return {
      height: 0,
      width: 0,
      modifier: 1,
      resizeTimer: null,
    }
  },
  methods: {
    handleMouseOver () {
      if (this.active) {
        this.modifier = 1
        return
      }
      this.modifier = 1.1
    },
    handleMouseOut () {
      // if (this.active) return
      this.modifier = 1
    },
    storeDimensions () {
      this.width = this.$el.offsetWidth
      this.height = this.$el.offsetWidth * this.image.ImgData.ratio
    },
  },
  computed: {
    image () {
      // const name = this.content.name
      //   .replace(/\s+/gi, '')
      //   .toLowerCase()
      return this.$root.content.allImages[this.content.image]
    },
    team () {
      return this.$root.content.teams[this.content.team.toLowerCase().replace(/\s+/gi, '_')]
    },
    versus () {
      return this.$root.content.teams[this.content.versus.toLowerCase().replace(/\s+/gi, '_')]
    },
    badge () {
      // const team = this.$root.content.teams[this.content.team.toLowerCase().replace(/\s+/gi, '_')]
      const badgeInfo = this.$root.content.teams.tigers
      return badgeInfo
    },
    topHeight () {
      return {
        // height: `${this.height}px`,
        // height: 0,
        // paddingBottom: '70%',
      }
    },
  },
  updated () {
    if (this.active) this.modifier = 1
  },
  mounted () {
    this.$nextTick(() => {
      this.storeDimensions()
      window.addEventListener('resize', () => {
        if (this.resizeTimer) {
          clearTimeout(this.resizeTimer)
        }
        this.resizeTimer = setTimeout(this.storeDimensions, 200)
      })
    })
  }
}
</script>


<style scoped lang="sass">
*
  // outline: solid 1px cyan
  // border: solid 1px red

@import index
.wrapper
  // border: solid 1px red
  // justify-content: space-around
  // justify-content: space-between
  // flex-direction: row
  vertical-align: top
  // height: 500px
  overflow: hidden
  &.shouldHover:hover
    .wrapper__image
      transform: scale(1.1)
      // img
  &__text
    // border: solid 1px pink
    transition: all 300ms
    position: absolute
    bottom: 0
    left: 0
    min-height: 70px
    height: 30%
    vertical-align: top
    color: white
    // min-width: 130px
    width: 100%
    z-index: 10
    clip-path: polygon(0 0, 100% 50%, 100% 100%, 0 100%)
    .colorOverlay
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      z-index: 0
      opacity: 0.5
    &--inner
      top: 50%
      padding: 16px
      padding-right: 32px
      transform: translate(0, -50%)
      z-index: 10

  &__image
    transition: transform 250ms
    vertical-align: top
    overflow: hidden
    img
      transition: transform 300ms
      transform-origin: bottom
      margin: 0
  h4
    text-transform: uppercase
    margin-bottom: 4px
    font-size: 14px
    letter-spacing: 1px
  h3
    font-size: 24px
    line-height: 20px
    margin: 0
    // &:last-of-type
      // margin-bottom: 16px

  .badge
    position: absolute
    right: 0
    bottom: 0
    width: 40px
    height: 40px
    border-radius: 100px
    background: white
    background-position: 0 0
    border: solid 1px rgba(white, 0.6)
    overflow: hidden
    z-index: 100
    transform: translate(-50%, -30%) scale(1)
    img
      margin: 0
      transform: scale(1)



</style>



// WEBPACK FOOTER //
// src/components/dally-m/games-top.vue